/** Oruga animada para el control de BPM (estilo Junior). */
export function BpmCaterpillar() {
  return (
    <svg
      className="bpm-caterpillar"
      viewBox="0 0 48 32"
      aria-hidden="true"
      width="40"
      height="28"
    >
      <ellipse cx="38" cy="16" rx="8" ry="9" fill="#66BB6A" />
      <circle cx="42" cy="13" r="1.8" fill="#1B5E20" />
      <circle cx="44" cy="13" r="1.8" fill="#1B5E20" />
      <path
        d="M44 10 Q48 6 46 4"
        fill="none"
        stroke="#388E3C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <ellipse cx="28" cy="16" rx="7" ry="8" fill="#81C784" />
      <ellipse cx="19" cy="16" rx="7" ry="8" fill="#66BB6A" />
      <ellipse cx="10" cy="16" rx="7" ry="8" fill="#4CAF50" />
      <ellipse cx="4" cy="16" rx="5" ry="7" fill="#43A047" />
    </svg>
  );
}
